import { render, staticRenderFns } from "./KBDrawer.vue?vue&type=template&id=756ae29c&scoped=true&"
import script from "./KBDrawer.vue?vue&type=script&lang=ts&"
export * from "./KBDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./KBDrawer.vue?vue&type=style&index=0&id=756ae29c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756ae29c",
  null
  
)

export default component.exports